import { render } from "./BaseCarousel.vue?vue&type=template&id=56a58be2"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import "../assets/styles/carousels.css?vue&type=style&index=0&lang=css&external"
import "../assets/styles/carousels_theme_colours.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__